var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slider',{ref:"slider",attrs:{"item-reward-slider":"","option":_vm.option,"pagination":_vm.slides.length > 1,"pagination-type":"bullets","loop":_vm.slides.length > 1,"info":_vm.slides,"navigation":""},on:{"touchIn":_vm.touchStart,"touchOut":_vm.touchEnd},scopedSlots:_vm._u([{key:"slide",fn:function(ref){
var info = ref.info;
return [_c(info,{tag:"component"})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }